<template >
  <div id="builder" :ref="'top'" :class="{'builder-mobile-mode': isMobileBuilder}">
    <div class="mainframe builder-screen">
      <div v-if="!isMobileBuilder" class="menu-component collaps">
        <Menu v-bind:menu="menu"/>
      </div>
      <div v-if="!isMobileBuilder" :style="[{top: vertPosition}]" :class="{'extended': menuExtended}" class="collapsed-menu-component">
        <!-- <span @click="pxFromTop($refs.top)">{{this.pxFromTop($refs.top)}}</span> -->
        <MenuCollapsible :extended="getWidth() > 584 ? menuExtended : true" />
        
      </div>
      <div v-if="!isMobileBuilder && getWidth() < 584 && getCurrentPartType && getCurrentPartType !==''"  class="mobile-items-popup" :class="{'open': getCurrentPartType && getCurrentPartType !==''}">
        
        <MobileItems />
      </div>
      <div class="page-router-component">
        <section v-if="showBetaNotice" class="builder-beta-notice" aria-label="Builder beta status">
          <div class="beta-mark">
            <span></span>
          </div>
          <div class="beta-copy">
            <strong>Builder beta</strong>
            <p>GixCore is under very active development. We are polishing compatibility, catalog depth, and mobile workflows. Your patience will be rewarded. Check back soon.</p>
          </div>
          <button
            type="button"
            class="beta-dismiss"
            aria-label="Dismiss builder beta message"
            @click="dismissBetaNotice"
          >
            <span class="icon icon-check"></span>
          </button>
        </section>
        <PageRouter/>
      </div>
      <MobileBuildDock v-if="isMobileBuilder" />
      <b-toast
        v-model="handoffToastVisible"
        toaster="b-toaster-bottom-right"
        toast-class="builder-handoff-toast"
        :auto-hide-delay="5000"
        no-close-button
        solid
        @hidden="clearHandoffToast"
      >
        <div class="builder-handoff-snackbar">
          <span class="builder-handoff-snackbar__mark" aria-hidden="true">✓</span>
          <strong>{{ handoffToast.message }}</strong>
          <button v-if="handoffToast.undo" type="button" @click="undoHandoff">Undo</button>
        </div>
      </b-toast>
    </div>
  </div>
</template>

<script>
import Menu                 from './Menu.vue'
import MenuCollapsible      from './MunuCollapsible.vue'
import PageRouter           from './PageRouter.vue'
import {EventBus}           from '../../eventBus'
import MobileItems          from './MobileItems.vue'
import MobileBuildDock      from './MobileBuildDock.vue'
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'Builder',
  components: {
    PageRouter,
    Menu,
    MenuCollapsible,
    MobileItems,
    MobileBuildDock,
  },
  props: ["menu"],
  data(){
    return {
      vertPosition: '',
      menuExtended: false,
      posBoxA: 0,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
      showBetaNotice: false,
      handoffToastVisible: false,
      handoffToast: {
        message: '',
        undo: null,
      },
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentPartType',
      'hasUnsavedChanges',
      'getSavedBuildName'
    ]),
    isMobileBuilder(){
      return this.viewportWidth <= 760
    }
  },
  methods: {
    ...mapActions([
      'setCurrentPartType'
    ]),
    // pxFromTop(el){
    //   console.log(this.calcPosOfBox())
    //   if(el){
    //     console.log('got element, ', el.getBoundingClientRect().x+'px')
    //     return el.getBoundingClientRect().x+'px'
    //   }
    //   return '0px'
    // },
    getWidth(){
        return this.viewportWidth
    },
    syncViewportWidth(){
      if(typeof window !== 'undefined'){
        this.viewportWidth = window.innerWidth
      }
    },
    syncBetaNotice(){
      if(typeof window === 'undefined' || !window.localStorage){
        this.showBetaNotice = true
        return
      }
      try {
        this.showBetaNotice = window.localStorage.getItem('viewedBetaMessage') !== '1'
      } catch {
        this.showBetaNotice = true
      }
    },
    dismissBetaNotice(){
      this.showBetaNotice = false
      if(typeof window === 'undefined' || !window.localStorage){
        return
      }
      try {
        window.localStorage.setItem('viewedBetaMessage', '1')
      } catch {
        // Ignore storage failures; the in-session dismiss still works.
      }
    },
    showHandoffToast(payload){
      this.handoffToast = {
        message: payload && payload.message ? payload.message : 'Build updated.',
        undo: payload && typeof payload.undo === 'function' ? payload.undo : null,
      }
      this.handoffToastVisible = true
    },
    async undoHandoff(){
      var undo = this.handoffToast.undo
      this.handoffToastVisible = false
      if(undo){
        await undo()
      }
      this.clearHandoffToast()
    },
    clearHandoffToast(){
      this.handoffToast = { message: '', undo: null }
    },
    calcPosOfBox() {
      const boxABB = this.$refs["top"].getBoundingClientRect();
      this.posBoxA = boxABB.x;

    },
    // Tab close / reload. The browser shows its own generic wording; the only
    // thing a page can control is whether the dialog appears at all.
    handleBeforeUnload(event) {
      if(!this.hasUnsavedChanges){ return }
      event.preventDefault()
      event.returnValue = ''
      return ''
    },
  },
  // Only fires when leaving the builder entirely. Moving between part pages
  // (/builder/cpu -> /builder/gpu) keeps this component mounted and does not
  // trigger it, which is what stops the prompt appearing on every part change.
  //
  // A new build needs no prompt: it is already persisted to localStorage and is
  // restored on return. Only an opened saved build can actually lose work.
  beforeRouteLeave(to, from, next) {
    if(!this.hasUnsavedChanges){
      next()
      return
    }
    var name = this.getSavedBuildName || 'this build'
    var leave = window.confirm(
      'You have unsaved changes to "' + name + '".\n\n'
      + 'Leave without saving? Your changes will be kept in this browser, but the saved build will not be updated.'
    )
    next(leave)
  },
  mounted(){
    this.syncViewportWidth()
    this.syncBetaNotice()
    if(typeof window !== 'undefined'){
      window.addEventListener('resize', this.syncViewportWidth)
      window.addEventListener('beforeunload', this.handleBeforeUnload)
    }
    this.calcPosOfBox()
    EventBus.$on('extended', (bool) => {
      console.log('received extendMenu', bool)
      this.menuExtended = bool
    })
    EventBus.$on('builder-handoff-toast', this.showHandoffToast)
  },
  beforeDestroy(){
    EventBus.$off('builder-handoff-toast', this.showHandoffToast)
    if(typeof window !== 'undefined'){
      window.removeEventListener('resize', this.syncViewportWidth)
      window.removeEventListener('beforeunload', this.handleBeforeUnload)
    }
  },
}
</script>

<style>
.mobile-items-popup {
  height: 0px;

  position: absolute;
  z-index: 99999999;
  bottom: 0px;
    left: 0px;
    right: 0px;
    top: 66px;
    padding-left: 20px;
    padding-right: 15px;
  background-color: #191b20;
  overflow: scroll;
  overflow-x: hidden;
}
.mobile-items-popup.open {
  height: 100vh;
}
.bg-dark {
  background-color: #191b20 !important;
}
.navbar-dark {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.navbar-small {
  max-height: 45px;
}
#builder .menu-component {
  display: inline-block;
  width: 26%;
  min-width: 309px;
  margin-top: 10px;
  padding-bottom: 7px;
}
.menu-title {
  display: inline-block;
}
.h4-indicator {
  display: inline-block;
  float: right;
}
#builder .collapsed-menu-component {
  overflow: hidden;
  border: 1px solid #434857;
  width: 87px;
  max-height: 82vh;
  border-radius: 6px;
  position: absolute;
  display: none;
  background-color: #191b20;
  z-index: 9999;
  margin-top: 12px;
}
@media screen and (max-width: 1200px) {
  #builder .collapsed-menu-component {
    top: 86px;
    left: 0;
    padding-bottom: 5px;
    display: block;
    transition: 0.2s
    
  }
  #builder .collapsed-menu-component.extended {
    width: 370px;
    min-width:350px;
    padding-right: 7px;
    padding-right: 7px;
    /* padding-right: 15px; */
    
  }
  #builder .menu-component {
    display: none;
  }
  #builder .collaps {
    transition: 0.2s;
    position: fixed;
    background-color: #191b20;
    z-index: 99999;
  }


  #builder > .mainframe > .page-router-component {
    box-sizing: border-box;
    width: 100% !important;
    margin-top: 0px !important;
    padding-right: 16px;
    padding-left: 96px;
    overflow-x: hidden;
   }
  .item-list {
    max-height: unset;
  }
  .brands {
    display: none;
  }
  .slider {
    text-align: center;
  }
}

@media screen and (min-width: 761px) and (max-width: 1200px) {
  #builder {
    min-width: 0;
  }

  #builder .mainframe {
    display: block;
    position: relative;
    width: 100%;
    min-width: 0;
    padding-left: 0;
  }

  #builder .collapsed-menu-component {
    position: fixed;
    top: 88px !important;
    left: 0;
    z-index: 90;
    width: 78px;
    max-height: calc(100vh - 110px);
    margin-top: 0;
    overflow-x: hidden;
    overflow-y: auto;
    border-color: rgba(74, 82, 103, 0.78);
    border-left: 0;
    border-radius: 0 8px 8px 0;
    background:
      radial-gradient(circle at 0 18%, rgba(25, 151, 198, 0.13), rgba(25, 151, 198, 0) 36%),
      rgba(8, 11, 17, 0.82);
    box-shadow:
      16px 0 34px rgba(0, 0, 0, 0.22),
      inset 1px 0 0 rgba(255, 255, 255, 0.035);
    backdrop-filter: blur(8px);
  }

  #builder .collapsed-menu-component.extended {
    z-index: 1200;
    width: min(356px, calc(100vw - 32px));
    min-width: 0;
  }

  #builder > .mainframe > .page-router-component {
    display: block;
    width: 100% !important;
    max-width: 100%;
    min-width: 0;
    padding-left: 96px;
    padding-right: 16px;
    overflow: visible;
  }
}

@media screen and (min-width: 761px) and (max-width: 940px) {
  #builder > .mainframe > .page-router-component {
    padding-right: 12px;
    padding-left: 90px;
  }
}

@media screen and (max-width: 760px) {
  #builder.builder-mobile-mode {
    min-width: 0;
  }

  #builder.builder-mobile-mode .mainframe {
    display: block;
    width: 100%;
    margin-bottom: 0;
    padding: 0 0 calc(88px + env(safe-area-inset-bottom, 0px));
  }

  #builder.builder-mobile-mode > .mainframe > .page-router-component {
    display: block;
    width: 100% !important;
    min-height: 0;
    margin-top: 0 !important;
    padding-right: 12px;
    padding-left: 12px;
  }

  #builder.builder-mobile-mode .brands {
    display: block;
  }
}

@media screen and (max-height: 820px) and (min-width: 1201px) {
  #builder .menu-component {
    margin-top: 0;
  }
}

@media screen and (max-height: 720px) and (min-width: 1201px) {
  #builder .menu-component {
    margin-top: -4px;
  }
}
@media screen and (max-width: 475px) {
  #builder .collapsed-menu-component.extended {
    width: 92vw;
    overflow-y:scroll;

  }
}
#builder > .mainframe > .page-router-component {
  margin-top: 0;
  display: inline-block;
  width: 73%;
  min-height: calc(100vh - 120px);
  vertical-align: top;
}

.builder-beta-notice {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  margin: 0 0 10px;
  padding: 8px 11px;
  border: 1px solid rgba(32, 184, 235, 0.42);
  border-radius: 8px;
  background:
    radial-gradient(circle at 4% 0%, rgba(32, 184, 235, 0.18), rgba(32, 184, 235, 0) 34%),
    linear-gradient(135deg, rgba(9, 17, 26, 0.92), rgba(7, 10, 16, 0.74));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 12px 34px rgba(0, 0, 0, 0.22);
  color: #dce2ee;
}

.beta-mark {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border: 1px solid rgba(32, 184, 235, 0.56);
  border-radius: 7px;
  background: rgba(4, 55, 75, 0.32);
}

.beta-mark span {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #20c8f8;
  box-shadow: 0 0 18px rgba(32, 200, 248, 0.78);
}

.beta-mark span::after {
  position: absolute;
  inset: -5px;
  border: 1px solid rgba(32, 200, 248, 0.38);
  border-radius: 50%;
  content: "";
}

.beta-copy {
  display: flex;
  align-items: baseline;
  gap: 9px;
  min-width: 0;
}

.beta-copy strong {
  flex: 0 0 auto;
  color: #20c8f8;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.beta-copy p {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #aeb8ca;
  font-size: 12px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.beta-dismiss {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid rgba(32, 184, 235, 0.58);
  border-radius: 7px;
  outline: none;
  background: rgba(32, 184, 235, 0.08);
  color: #20c8f8;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, color 160ms ease;
}

.beta-dismiss:hover,
.beta-dismiss:focus {
  border-color: rgba(32, 200, 248, 0.9);
  background: rgba(32, 184, 235, 0.16);
  box-shadow: 0 0 18px rgba(32, 184, 235, 0.16);
  color: #f4f8fb;
}

.beta-dismiss .icon {
  margin: 0 !important;
  font-size: 15px;
  line-height: 1;
}

.mainframe {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-left: 0px;
}

.builder-handoff-toast {
  overflow: hidden;
  border: 1px solid rgba(44, 194, 232, 0.58) !important;
  border-radius: 8px !important;
  background: rgba(7, 15, 24, 0.97) !important;
  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.48), inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;
  color: #e6edf5 !important;
  backdrop-filter: blur(12px);
}

.builder-handoff-toast .toast-body {
  padding: 0.8rem 0.9rem !important;
}

.builder-handoff-snackbar {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.7rem;
}

.builder-handoff-snackbar__mark {
  display: inline-grid;
  width: 27px;
  height: 27px;
  place-items: center;
  border: 1px solid rgba(0, 188, 140, 0.52);
  border-radius: 7px;
  background: rgba(0, 188, 140, 0.1);
  color: #39d5a9;
  font-size: 14px;
  font-weight: 900;
}

.builder-handoff-snackbar strong {
  color: #e6edf5;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
}

.builder-handoff-snackbar button {
  padding: 0.34rem 0.55rem;
  border: 1px solid rgba(47, 194, 238, 0.58);
  border-radius: 6px;
  outline: none;
  background: rgba(32, 184, 235, 0.08);
  color: #43c9f1;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.builder-handoff-snackbar button:hover,
.builder-handoff-snackbar button:focus {
  border-color: #43c9f1;
  background: rgba(32, 184, 235, 0.17);
  color: #f4fbff;
}

.builder-handoff-confirm .modal-content {
  overflow: hidden;
  border: 1px solid rgba(62, 178, 218, 0.5);
  border-radius: 9px;
  background: #0c111a;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.56);
  color: #dfe6ef;
}

.builder-handoff-confirm .modal-header,
.builder-handoff-confirm .modal-footer {
  border-color: rgba(74, 84, 105, 0.5);
}

.builder-handoff-confirm .modal-title {
  color: #eef3f8;
  font-size: 16px;
  font-weight: 750;
}

.builder-handoff-confirm .modal-body {
  color: #aeb8c8;
  font-size: 13px;
  line-height: 1.55;
}

.builder-handoff-choice .modal-dialog {
  max-width: 540px;
}

.builder-handoff-choice .modal-content {
  overflow: hidden;
  border: 1px solid rgba(48, 185, 228, 0.48);
  border-radius: 10px;
  background:
    radial-gradient(circle at 100% 0, rgba(22, 180, 237, 0.12), transparent 42%),
    #0b111a;
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.62);
  color: #e4ebf3;
}

.builder-handoff-choice .modal-body {
  padding: 0;
}

.handoff-choice {
  padding: 1.45rem;
}

.handoff-choice__eyebrow {
  display: block;
  margin-bottom: 0.45rem;
  color: #2bc2ef;
  font-size: 10px;
  font-weight: 850;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.handoff-choice h3 {
  margin: 0;
  color: #f0f4f8;
  font-size: 20px;
  line-height: 1.25;
}

.handoff-choice p {
  margin: 0.75rem 0 1.25rem;
  color: #9da9ba;
  font-size: 13px;
  line-height: 1.58;
}

.handoff-choice p strong {
  color: #e7edf5;
}

.handoff-choice__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.55rem;
}

.handoff-choice__actions button {
  min-height: 36px;
  padding: 0.55rem 0.8rem;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.025em;
}

.handoff-choice__cancel {
  margin-right: auto;
  border: 1px solid transparent;
  background: transparent;
  color: #8e9aad;
}

.handoff-choice__secondary {
  border: 1px solid rgba(124, 139, 160, 0.5);
  background: rgba(124, 139, 160, 0.06);
  color: #c7d0dc;
}

.handoff-choice__primary {
  border: 1px solid #20b8eb;
  background: linear-gradient(180deg, #27bee9, #149bc9);
  color: #041019;
}

.handoff-choice__actions button:hover,
.handoff-choice__actions button:focus {
  filter: brightness(1.12);
  outline: none;
}

@media screen and (max-width: 560px) {
  .handoff-choice__actions {
    flex-direction: column-reverse;
  }

  .handoff-choice__actions button,
  .handoff-choice__cancel {
    width: 100%;
    margin-right: 0;
  }
}

@media screen and (min-width: 1201px) {
  #builder .builder-screen {
    position: relative;
    display: grid;
    grid-template-columns: minmax(309px, 26%) minmax(0, 1fr);
    align-items: stretch;
    border: 1px solid rgba(70, 82, 105, 0.24);
    border-radius: 12px;
    background:
      radial-gradient(circle at 24% 0%, rgba(25, 151, 198, 0.07), transparent 31%),
      linear-gradient(90deg, rgba(10, 15, 23, 0.34), rgba(5, 10, 16, 0.18) 42%, rgba(5, 10, 16, 0.08));
    box-shadow:
      inset 0 1px 0 rgba(65, 183, 223, 0.1),
      inset 0 -1px 0 rgba(70, 82, 105, 0.12);
  }

  #builder .builder-screen > .menu-component {
    display: flex;
    flex-direction: column;
    align-self: stretch;
    width: auto;
    min-width: 0;
    height: auto;
    padding-bottom: 0;
    border-radius: 12px 0 0 12px;
    background: linear-gradient(90deg, rgba(9, 14, 22, 0.14), rgba(10, 22, 31, 0.28));
  }

  #builder > .builder-screen > .page-router-component {
    box-sizing: border-box;
    width: auto;
    min-width: 0;
    min-height: 0;
    border-radius: 0 12px 12px 0;
    background: linear-gradient(90deg, rgba(25, 151, 198, 0.025), transparent 18%);
  }
}

@media screen and (max-width: 760px) {
  .builder-beta-notice {
    gap: 8px;
    margin-bottom: 10px;
    padding: 8px 10px;
  }

  .beta-mark {
    width: 24px;
    height: 24px;
  }

  .beta-copy {
    display: block;
  }

  .beta-copy p {
    font-size: 12px;
    white-space: normal;
  }

  .beta-dismiss {
    align-self: start;
    width: 28px;
    height: 28px;
  }
}
</style>
